export function isAsyncIterable(value) {
    return Symbol.asyncIterator in value;
}
//# sourceMappingURL=isAsyncIterable.js.map